import { lazy } from '@/service/lazy'

export default [{
  name: 'Consulta Hiscon',
  path: 'consultahiscon',
  id: 'consultahiscon',
  icon: 'fa fa-shield',
  component: lazy('app/default/hiscon/index'),
  meta: { requireAuth: true, rules: ['consulta_hiscon'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/hiscon.js